import React from 'react'
import { InputWrapper, InputWrapperDirection } from '.'
import { Row } from '@/components/core'
import { classNameBuilder } from '@/helpers'
import { UncontrolledFormElement } from '@/types/themeType'

interface CheckBoxInputProps extends UncontrolledFormElement {
  direction?: InputWrapperDirection
  checked: boolean
  className?: { input?: string; wrapper?: string; label?: string }
}

export const CheckboxInput: React.FC<CheckBoxInputProps> = ({
  id,
  label,
  checked,
  disabled,
  required,
  error,
  className,
  direction,
  onChange,
  ...inputProps
}) => {
  return (
    <InputWrapper
      labelStyle={className?.label}
      className={className?.wrapper}
      error={error}
      direction={direction}
      required={required}
      disabled={disabled}
    >
      <Row className="gap-3">
        <div
          className={classNameBuilder(
            'relative flex h-5 w-5 rounded-[100%]',
            checked ? 'bg-[#E6D7FF]' : 'bg-none'
          )}
        >
          <input
            id={id}
            {...inputProps}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className={classNameBuilder(
              'checked:bg-blue-500 peer cursor-pointer rounded-[100%]  border-[#818181] outline-0 transition duration-300 ease-in-out checked:bg-none focus:ring-0 focus:ring-offset-0',
              checked
                ? 'top absolute left-[4px] top-[4px] h-3 w-3 md:left-[4.5px]'
                : 'h-5 w-5'
            )}
            style={{ backgroundColor: checked ? '#6A0DFD' : 'transparent' }}
          />
        </div>
        <label
          htmlFor={id}
          className="text-md text-[#353535]-400 cursor-pointer"
          onClick={() =>
            onChange &&
            onChange({
              target: { checked: !checked },
              currentTarget: { id, checked: !checked, value: label }
            } as React.ChangeEvent<HTMLInputElement>)
          }
        >
          {label}
        </label>
      </Row>
    </InputWrapper>
  )
}

export default CheckboxInput
